module.exports = __webpack_public_path__ + "img/header.357ebda5.jpg";